import { render, staticRenderFns } from "./SearchFrame.vue?vue&type=template&id=27527ddc&"
import script from "./SearchFrame.vue?vue&type=script&lang=js&"
export * from "./SearchFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports